import React, { useContext, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { setBackdropLoadingAction } from 'store/actions/mainPage';
import { httpClient } from 'utils/httpClient';
import {
  resetClusterPointsAndInfoAction,
  setAllPointsActionVL,
  setPointsActionVL,
} from 'store/actions/vectorLayers';
import {
  scale_1_50_vector_clusterZoom,
  scale_1_50_vector_MapMaxZoom,
} from '../../constants';
import MapContext from '../../MapContext';

const URL = process.env.REACT_APP_API_URL;

export const LayerClustersHandler: React.FC = () => {
  const { lang, isLogged } = useAppSelector((state) => state.mainPage);
  const { map } = useContext(MapContext);
  const { foundPoints, needUpdateClusterInfo } = useAppSelector(
    (state) => state.vectorLayers
  );
  const abortControllerRef = useRef<AbortController | null>(null);
  const dispatch = useAppDispatch();

  const { currentLayer, currentLayerId, layer_scale_1_50_vector } =
    useAppSelector((state) => state.layers);

  const getClusters = async () => {
    try {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      dispatch(setBackdropLoadingAction(true));

      const controller = new AbortController();
      abortControllerRef.current = controller;

      const res = await httpClient.post(
        `${URL}/api/${isLogged ? 'pv-' : ''}layerpoints`,
        {
          lang,
          layer: currentLayerId,
        },
        { signal: controller.signal }
      );
      const _allPoints = res.data.data;
      const allPoints = _allPoints[0];
      const points = allPoints.items;

      dispatch(setAllPointsActionVL(allPoints));
      dispatch(setPointsActionVL(points));
    } catch (error: any) {
      if (error.name === 'AbortError') {
        console.log('Запрос отменен');
      } else {
        console.error('Ошибка при загрузке кластеров:', error);
      }
    } finally {
      dispatch(setBackdropLoadingAction(false));
      abortControllerRef.current = null;
    }
  };

  const getScale_1_50_clusters = () => {
    const zoom = map.getView().getZoom();

    if (zoom > scale_1_50_vector_clusterZoom) {
      if (!foundPoints.length && !abortControllerRef.current) {
        getClusters();
      }
    } else if (zoom < scale_1_50_vector_clusterZoom) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    }
  };

  useEffect(() => {
    if (!map || !layer_scale_1_50_vector) return;
    map.getView().setMaxZoom(scale_1_50_vector_MapMaxZoom);

    map.on('moveend', getScale_1_50_clusters);

    return () => {
      map.un('moveend', getScale_1_50_clusters);

      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [map, layer_scale_1_50_vector, foundPoints, currentLayer]);

  useEffect(() => {
    if (!map) return;
    const zoom = map.getView().getZoom();

    if (layer_scale_1_50_vector && zoom > scale_1_50_vector_clusterZoom) {
      getClusters();
    } else if (
      foundPoints.length &&
      (!layer_scale_1_50_vector || zoom < scale_1_50_vector_clusterZoom)
    ) {
      dispatch(resetClusterPointsAndInfoAction());
    }
  }, [map, currentLayerId]);

  return null;
};
